<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤统计->学生考勤原始记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="float:right;width:95%;">
            <div style="height:80px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="所属机构"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        v-model="form.startDatetime"
                        type="datetime"
                        placeholder="开始时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                        
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker
                        v-model="form.endDatetime"
                        type="datetime"
                        placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index"  fixed label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name"  fixed label="姓名" width="100"></el-table-column>
                <el-table-column prop="personType" label="人员类型" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.personType == 1">
                            学生
                        </div>
                        <div v-else-if="scope.row.personType == 2">
                            教职
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="identityCard" label="身份证" width="100"></el-table-column>
                <el-table-column prop="sex" label="性别" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sex == 1">
                            男
                        </div>
                        <div v-else-if="scope.row.sex == 2">
                            女
                        </div>
                        <div v-else-if="scope.row.sex == 0">
                            未知
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="className" label="所属机构" width="100"></el-table-column>
                <el-table-column prop="deviceNo" label="设备编号" width="150"></el-table-column>
                <el-table-column prop="address" label="设备位置" width="150"></el-table-column>
                <el-table-column prop="scanStartTime" label="扫描开始时间" width="130"></el-table-column>
                <el-table-column prop="scanEndTime" label="扫描结束时间" width="130"></el-table-column>
                <el-table-column prop="gmtCreate" label="生成时间" width="130"></el-table-column>
                <el-table-column prop="remark" label="备注" width="150"></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';

    export default {
        name:"StudentAbsence",
        data(){
            return{
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    identityCard:"",
                    personType:"",
                    className:"",
                    startDatetime:"",
                    endDatetime:"",
                    deptId:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                personTypes:[{
                    value: '',
                    label: '全部'
                },{
                    value: '1',
                    label: '学生'
                }, {
                    value: '2',
                    label: '教职'
                }]
            }
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                       }
                       this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.listStudentAbsenceRecordUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    personType:this.form.personType,
                    className:this.form.className,
                    startDatetime:this.form.startDatetime==null?"":this.form.startDatetime,
                    endDatetime:this.form.endDatetime==null?"":this.form.endDatetime,
                    deptId:this.form.deptId
                };
                
                // console.log(JSON.stringify(data))

                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.trafficRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/report/StudentAbsence.vue